import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export interface IDashPoints{
  time: string
  stops?: number
  isDesktop?: boolean;
}

function DashPoints(props: IDashPoints) {
  const { time, stops, isDesktop } = props;
  return (
    <Box sx={{
      width: isDesktop ? '80%' : '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      transform: 'translateY(-30%)',
    }}
    >
      <Typography variant="captionMedium">
        {time}
      </Typography>
      {!!stops && stops > 0 && (
      <Box sx={{
        width: '6px',
        height: '6px',
        backgroundColor: '#8897A5',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: ' translateX(-50%) translateY(-50%)',
        borderRadius: '50%',
      }}
      />
      )}
      <Box sx={{
        width: '100%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: ' translateX(-50%) translateY(-50%)',
      }}
      >
        <FiberManualRecordIcon sx={{
          position: 'absolute',
          fontSize: '8px',
          top: '-4px',
          left: '-5px',
          fill: '#667487',
        }}
        />
        <Divider sx={{
          borderTop: '1px dashed #8897A5',
          borderBottomWidth: 0,
        }}
        />
        <FiberManualRecordIcon sx={{
          position: 'absolute',
          fontSize: '8px',
          top: '-4px',
          right: '-5px',
          fill: '#667487',
        }}
        />
      </Box>
      <Typography
        mt={1}
        variant="captionRegular"
      >
        { stops && stops > 0 ? `${stops} điểm dừng` : 'Bay thẳng'}
      </Typography>
    </Box>
  );
}

export default DashPoints;
